import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const dashboardService = {
  getDashboardData: (params: { userName: string }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getDashboardData(),
      config: { params },
    });
  },
};

export default dashboardService;
